export const TRUNG_THU_CAMERA_STORAGE_KEY = "posTrungThuPreferredCameraId";

const normalizeCameraLabel = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("vi");

const isFrontCameraLabel = (label) =>
  /\b(front|user|selfie|facetime)\b|mặt trước|phía trước/.test(label);

const isRearCameraLabel = (label) =>
  /\b(back|rear|environment|world)\b|mặt sau|phía sau/.test(label);

const isAuxiliaryRearCameraLabel = (label) =>
  /ultra[\s-]*wide|0[.,]5\s*x|tele(photo)?|macro|depth/.test(label);

const isMainRearCameraLabel = (label) =>
  /\b(main|primary|1\s*x)\b/.test(label) ||
  (/\bwide\b/.test(label) && !/ultra[\s-]*wide/.test(label));

const getCameraPreferenceScore = (device, currentDeviceId) => {
  const label = normalizeCameraLabel(device?.label);
  let score = device?.deviceId === currentDeviceId ? 20 : 0;

  if (isRearCameraLabel(label)) score += 100;
  if (isMainRearCameraLabel(label)) score += 40;
  if (isAuxiliaryRearCameraLabel(label)) score -= 300;
  if (isFrontCameraLabel(label)) score -= 500;

  return score;
};

export const getVideoInputDevices = (devices) =>
  (Array.isArray(devices) ? devices : []).filter(
    (device) => device?.kind === "videoinput" && device.deviceId,
  );

export const selectPreferredCameraDevice = (
  devices,
  { savedDeviceId = "", currentDeviceId = "" } = {},
) => {
  const videoDevices = getVideoInputDevices(devices);
  if (videoDevices.length === 0) return null;

  const savedDevice = videoDevices.find(
    (device) => device.deviceId === savedDeviceId,
  );
  if (savedDevice) return savedDevice;

  return videoDevices.reduce((preferredDevice, device) =>
    getCameraPreferenceScore(device, currentDeviceId) >
    getCameraPreferenceScore(preferredDevice, currentDeviceId)
      ? device
      : preferredDevice,
  );
};

export const getCameraOptionLabel = (device, index) => {
  const label = String(device?.label || "").trim();
  return label || `Camera ${index + 1}`;
};
